(function (root) {
  'use strict';
  const models = {
    Chevrolet: ['Astro Van','Avalanche','Express Van 1500','Silverado 1500','Silverado 2500','Silverado 3500','Suburban','Tahoe'],
    GMC: ['Safari','Savanna Van 1500','Sierra 1500','Sierra 2500','Sierra 3500','Yukon Denali','Yukon XL','Yukon'],
    Cadillac: ['Escalade ESV','Escalade EXT','Escalade'],
    Toyota: ['4Runner','FJ Cruiser','Sequoia','Tacoma','Tundra'],
    Lexus: ['GX460','GX470','LX570','GX'], Ford: ['Expedition','F-150'], Lincoln: ['Navigator'],
    Chrysler: ['300'], Dodge: ['Challenger','Charger','Durango','Magnum'], Jeep: ['Grand Cherokee'],
    'Land Rover': ['Range Rover Sport','Range Rover','LR3','LR4','HSE','Supercharged']
  };
  const normalize = x => String(x || '').toLowerCase().replace(/&amp;/g,'&').replace(/[^a-z0-9]+/g,' ').trim();
  const canonicalMake = x => /^(range rover|land rover)$/i.test(x) ? 'Land Rover' : Object.keys(models).find(k=>normalize(k)===normalize(x)) || x;
  const canonicalModel = x => String(x || '').replace(/^(Toyota|Lexus|Ford|Lincoln|Chevrolet|Chevy|GMC|Cadillac|Chrysler|Dodge|Jeep)\s+/i,'').replace(/^Denali$/i,'Yukon Denali');
  const decode = x => String(x).replace(/&nbsp;|&#160;/g,' ').replace(/&amp;/g,'&').replace(/&quot;/g,'"').replace(/&#39;|&apos;/g,"'").replace(/&ndash;|&#8211;/g,'–').replace(/&mdash;|&#8212;/g,'—');
  function applications(html) {
    const lines = decode(html).replace(/<br\s*\/?\s*>/gi,'\n').replace(/<\/(?:p|li|h[1-6]|div)>/gi,'\n').replace(/<[^>]*>/g,' ').split('\n').map(x=>x.replace(/\s+/g,' ').trim()).filter(Boolean);
    let active=false, make='', hardware=false;
    const result=[];
    for (let line of lines) {
      if (/replica disclosure/i.test(line)) break;
      if (/direct fit applications/i.test(line)) {active=true; line=line.split(/direct fit applications/i).slice(1).join(' ');}
      if (!active) continue;
      if (/new generation applications|requires special lug nuts/i.test(line)) hardware=true;
      const heading=Object.keys(models).find(k=>normalize(line)===normalize(k));
      if (heading) {make=heading; continue;}
      if (/^Range Rover\s*\(/i.test(line)) make='Land Rover';
      const explicit = Object.keys(models).find(k=>new RegExp('\\b'+k+'\\b','i').test(line));
      const rowMake=explicit || (/\bChevy\b/i.test(line)?'Chevrolet':make);
      if (!rowMake || !models[rowMake]) continue;
      if (explicit) make=explicit;
      line=line.replace(/Silverado\s+2500\s*\/\s*3500/gi,'Silverado 2500 / Silverado 3500').replace(/Sierra\s+2500\s*\/\s*3500/gi,'Sierra 2500 / Sierra 3500')
        .replace(/Escalade\s*\/\s*EXT\s*\/\s*ESV/gi,'Escalade / Escalade EXT / Escalade ESV').replace(/Yukon\s*\/\s*Yukon XL\s*\/\s*Denali/gi,'Yukon / Yukon XL / Yukon Denali');
      const n=' '+normalize(line)+' ';
      const dates=[...line.matchAll(/\b((?:19|20)\d{2})\s*(?:[–—-]\s*((?:19|20)\d{2}|present)|\+)?/gi)];
      const ranges=dates.length?dates.map(d=>({from:Number(d[1]),to:/present|\+/.test(d[0].toLowerCase())?new Date().getFullYear():Number(d[2]||d[1])})):[{from:null,to:null}];
      for (const model of models[rowMake]) {
        if (!n.includes(' '+normalize(model)+' ')) continue;
        // A longer model name must not also qualify the base vehicle.
        if (model==='GX' && /\bGX(?:460|470)\b/i.test(line)) continue;
        if (model==='Range Rover' && /Range Rover Sport/i.test(line) && !/Range Rover\s*\/|All years/i.test(line)) continue;
        for(const {from,to} of ranges) result.push({make:rowMake,model,from,to,hardware,note:hardware?'Special lug nuts and hub rings required.':/no manual locking hubs/i.test(line)?'Excludes manual locking hubs.':'Check trim, clearance and required hardware before mounting.'});
      }
    }
    return result.filter((r,i,a)=>a.findIndex(v=>JSON.stringify(v)===JSON.stringify(r))===i);
  }
  function specs(title,html) {
    const text=decode(html).replace(/<[^>]*>/g,' ').replace(/\s+/g,' ');
    const chunks=String(title).split('|').map(x=>x.trim());
    const size=title.match(/\b(\d{2}(?:\.\d+)?)[xX](\d+(?:\.\d+)?)/);
    const bolt=title.match(/\b([5-8])[xX](\d{3}(?:\.\d+)?)/);
    const finish=(chunks[2]||'').replace(/\s+OE[- ]Style Wheel.*/i,'').trim() || (text.match(/Finish:\s*(.+?)\s+Size:/i)||[])[1] || '';
    return {model:(title.match(/FFW\s+(F\d+)/i)||[])[1]||title,size:size?size[0]:'',diameter:size?size[1]:'',bolt:bolt?bolt[1]+'x'+bolt[2]:'',offset:(title.match(/[xX]\d+(?:\.\d+)?\s+([+-]\d+(?:\.\d+)?)/)||[])[1]||'',finish};
  }
  function match(rows,selection) {
    const makes=(selection.make||[]).map(canonicalMake);
    const model=normalize(canonicalModel(selection.model));
    const year=Number(selection.year)||0;
    const candidates=rows.filter(r=>(!makes.length||makes.includes(r.make))&&(!model||normalize(r.model)===model));
    if(!makes.length&&!model&&!year) return {status:'browse',rows};
    const exact=candidates.filter(r=>!year||(r.from!==null&&year>=r.from&&year<=r.to));
    if(exact.length) return {status:'match',rows:exact};
    const unknown=candidates.filter(r=>r.from===null);
    return {status:unknown.length?'verify':'none',rows:unknown};
  }
  const api={models,normalize,canonicalMake,canonicalModel,applications,specs,match};
  root.FFWFitment=api;
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
})(typeof window==='undefined'?globalThis:window);
